var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamTvIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 329,
    viewBox: "0 0 329 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 164.5,
    r: 164.5,
    fill: "#FAC87C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.828 236.531L121.913 217.164L127.466 222.923L107.381 242.29L101.828 236.531Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.13 236.531L197.045 217.164L191.492 222.923L211.577 242.29L217.13 236.531Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4343 100.643C59.4343 92.9114 65.7023 86.6434 73.4343 86.6434H244.806C252.538 86.6434 258.806 92.9114 258.806 100.643V210.326C258.806 218.058 252.538 224.326 244.806 224.326H73.4343C65.7023 224.326 59.4343 218.058 59.4343 210.326V100.643ZM73.4343 96.6434C71.2252 96.6434 69.4343 98.4343 69.4343 100.643V210.326C69.4343 212.535 71.2252 214.326 73.4343 214.326H244.806C247.015 214.326 248.806 212.535 248.806 210.326V100.643C248.806 98.4343 247.015 96.6434 244.806 96.6434H73.4343Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8461 108.99C74.8461 105.952 77.3086 103.49 80.3461 103.49H237.894C240.932 103.49 243.394 105.952 243.394 108.99V201.979C243.394 205.017 240.932 207.479 237.894 207.479H80.3461C77.3086 207.479 74.8461 205.017 74.8461 201.979V108.99ZM80.3461 108.49C80.07 108.49 79.8461 108.714 79.8461 108.99V201.979C79.8461 202.256 80.07 202.479 80.3461 202.479H237.894C238.17 202.479 238.394 202.256 238.394 201.979V108.99C238.394 108.714 238.17 108.49 237.894 108.49H80.3461Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.774 169.578C225.648 163.417 230.609 158.354 236.772 158.354H253.339C259.502 158.354 264.462 163.417 264.337 169.578L263.125 228.94C263.003 234.927 258.115 239.716 252.127 239.716H237.983C231.996 239.716 227.108 234.927 226.986 228.94L225.774 169.578Z",
    fill: "#4A4A4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.923,
    cy: 177.864,
    r: 2.07556,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.055,
    cy: 177.864,
    r: 2.07556,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.188,
    cy: 177.864,
    r: 2.07556,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.923,
    cy: 186.997,
    r: 2.07556,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.055,
    cy: 186.996,
    r: 2.07556,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.188,
    cy: 186.996,
    r: 2.07556,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.923,
    cy: 196.959,
    r: 2.07556,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.055,
    cy: 196.959,
    r: 2.07556,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.188,
    cy: 196.959,
    r: 2.07556,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.47,
    cy: 215.639,
    r: 6.6418,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.276 137.003C213.271 137.377 202.091 148.562 201.717 162.562C201.703 163.088 202.131 163.527 202.659 163.532L205.461 163.555C205.964 163.56 206.37 163.164 206.386 162.662C206.748 151.18 215.893 142.033 227.376 141.671C227.879 141.656 228.274 141.249 228.27 140.746L228.246 137.944C228.242 137.417 227.803 136.989 227.276 137.003ZM227.443 146.279C218.526 146.718 211.431 153.822 210.994 162.729C210.967 163.262 211.399 163.712 211.933 163.715L214.745 163.731C215.234 163.733 215.643 163.358 215.673 162.869C216.061 156.444 221.173 151.346 227.583 150.959C228.072 150.929 228.448 150.521 228.445 150.031L228.428 147.22C228.426 146.685 227.976 146.253 227.443 146.279Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamTvIllustration);
export default __webpack_public_path__ + "static/media/StreamTV-Illustration.63e6c58a14c8358fdaa53c450988da26.svg";
export { ForwardRef as ReactComponent };